import { render, staticRenderFns } from "./SearchTerms.vue?vue&type=template&id=2ff0430f&"
import script from "./SearchTerms.vue?vue&type=script&lang=ts&"
export * from "./SearchTerms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports